import { render, staticRenderFns } from "./EmptyGallery.vue?vue&type=template&id=e97d91b0&scoped=true&"
import script from "./EmptyGallery.vue?vue&type=script&lang=js&"
export * from "./EmptyGallery.vue?vue&type=script&lang=js&"
import style0 from "./EmptyGallery.vue?vue&type=style&index=0&id=e97d91b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97d91b0",
  null
  
)

export default component.exports